import { DatePicker } from './datePicker/datePicker'
import { FileRights } from './usersEdit/fileRights/fileRights'

export const Admin = (() => {
	const init = () => {
		FileRights.init()
		DatePicker.init()
	}

	return {
		init,
	}
})()
